import { useTranslation } from 'react-i18next'

import ErrorImage from 'shared/images/error.png'
import { PopupContent } from 'shared/ui/poup-content'

import { useDialogBottomSheet } from './useDialogBottomSheet'

interface Props {
  image?: string
  title?: string
  button?: string
  description?: string
  isCanClose?: boolean
  onClose?: () => void
}

export function useErrorPopUpStatus() {
  const { t } = useTranslation()

  const { openDialog, closeDialog } = useDialogBottomSheet()

  const useErrorPopUpStatusHandler = (data: Props | void) => {
    openDialog({
      isDialog: data?.isCanClose || false,
      child: (
        <PopupContent
          image={data?.image || ErrorImage}
          title={data?.title || t('error')}
          button={data?.button || t('close')}
          description={data?.description || t('please_tey_again')}
          onClick={data?.onClose || closeDialog}
        />
      ),
    })
  }

  return useErrorPopUpStatusHandler
}
